// Monotone cubic pieces: equal dates become vertical links; no division by zero or overshoot.
export function monotoneSegments(points) {
  const n = points.length;
  if (n < 2) return [];
  const dx = points.slice(1).map((p, i) => p.x - points[i].x);
  const slopes = dx.map((h, i) => h > 0 ? (points[i + 1].y - points[i].y) / h : 0);
  const tangents = points.map((_, i) => i === 0 ? slopes[0] : i === n - 1 ? slopes[n - 2] : slopes[i - 1] * slopes[i] <= 0 ? 0 : (slopes[i - 1] + slopes[i]) / 2);
  slopes.forEach((s, i) => {
    if (!s) { tangents[i] = 0; tangents[i + 1] = 0; return; }
    const a = tangents[i] / s, b = tangents[i + 1] / s;
    const length = Math.hypot(a, b);
    if (length > 3) { tangents[i] = 3 * a * s / length; tangents[i + 1] = 3 * b * s / length; }
  });
  return dx.map((h, i) => {
    const a = points[i], b = points[i + 1];
    return { start: a, end: b, c1: { x: a.x + h / 3, y: a.y + tangents[i] * h / 3 }, c2: { x: b.x - h / 3, y: b.y - tangents[i + 1] * h / 3 } };
  });
}
export const curveCommand = ({ c1, c2, end }) => `C${c1.x},${c1.y} ${c2.x},${c2.y} ${end.x},${end.y}`;
export const segmentPath = (s) => `M${s.start.x},${s.start.y} ${curveCommand(s)}`;
